import { render } from "./z-discover-skelet.vue?vue&type=template&id=1f5e1202&scoped=true"
const script = {}

import "./z-discover-skelet.vue?vue&type=style&index=0&id=1f5e1202&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5e1202"]])

export default __exports__